{% block prems_premium_item_configuration_hint %}
    <sw-alert variant="info">
        <p>{{ $tc('prems-premium-item.statistic-hint.intro') }}</p>
        <sw-button
                class="sw-order-list__add-order"
                variant="primary"
                @click="onClickStatisticButton"
        >
            {{ $tc('prems-premium-item.statistic-hint.button') }}
        </sw-button>
    </sw-alert>
{% endblock %}